import React from "react";

const restApiHost = 'https://demo.sagax.software/storage/';
export {restApiHost};